import React from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'

const MultipleSelectDisable = ({
  input,
  options,
  groupClassName,
  label,
  labelClassName,
  defaultValue,
  selectClassName,
  handleChange,
}) => {
  return (
    <div className={`form-group ${groupClassName}`}>
      {label && <label className={labelClassName}>{label}</label>}
      <div className={`form-control w-full`}>
        <Select
          name={input.name}
          className={selectClassName}
          isMulti
          value={defaultValue || null}
          options={options}
          isDisabled
          placeholder=""
          onChange={({ value }) => {
            console.log(value)
            input.onChange(value)
            handleChange && handleChange(value)
          }}
        ></Select>
      </div>
    </div>
  )
}

MultipleSelectDisable.propTypes = {
  selectClassName: PropTypes.string,
  label: PropTypes.string,
  groupClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  options: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  disabled: PropTypes.bool,
  defaultValue: PropTypes.array,
  input: PropTypes.object.isRequired,
  handleChange: PropTypes.func,
}

MultipleSelectDisable.defaultProps = {
  selectStyles: {
    control: (styles, { selectProps }) => ({
      ...styles,
      backgroundColor: '#edf2f7',
      borderRadius: selectProps.menuIsOpen ? '4px 4px 0 0' : '4px',
      border: 'none',
      boxShadow: 'none',
      '&:hover': {
        border: 'none',
      },
    }),
    dropdownIndicator: (styles, { selectProps }) => ({
      ...styles,
      transform: selectProps.menuIsOpen ? 'scaleY(-1)' : null,
    }),
    indicatorSeparator: (styles) => ({ ...styles, display: 'none' }),
  },
}

export default MultipleSelectDisable
